import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react';
import { HelmetProvider } from 'react-helmet-async';
import './index.css'
import App from './App.tsx'

const domain = import.meta.env.VITE_AUTH0_DOMAIN || "veltus.au.auth0.com";
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID || "7bqDdFZ0i9Yi86ERedDSpi1o4MLXmVV5";
const audience = `https://${domain}/api/v2/`;

createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: "openid profile email user_metadata offline_access"
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </HelmetProvider>,
);
